export default "__VITE_ASSET__8qNvxTNH__"